import React from "react";

import Select, { SelectProps } from "./Select";
import SelectSingleSearchable, {
  SelectSingleSearchableProps,
} from "./SelectSingleSearchable";
import SelectMultipleSearchable, {
  SelectMultipleSearchableProps,
} from "./SelectMultipleSearchable";

import { useForm } from "react-hook-form";

export type ReactHookFormProps = {
  name: string;
  control?: ReturnType<typeof useForm>["control"];
  register: ReturnType<typeof useForm>["register"];
  registerOptions?: Parameters<ReturnType<typeof useForm>["register"]>[1];
  unregister: ReturnType<typeof useForm>["unregister"];
  setValue: ReturnType<typeof useForm>["setValue"];
  setValueOptions?: Parameters<ReturnType<typeof useForm>["setValue"]>[2];
};

export default function SelectBase<T>(props: SelectProps<T>): JSX.Element;
export default function SelectBase<T>(
  props: SelectSingleSearchableProps<T>
): JSX.Element;
export default function SelectBase<T>(
  props: SelectMultipleSearchableProps<T>
): JSX.Element;
export default function SelectBase<T>(
  props:
    | SelectProps<T>
    | SelectSingleSearchableProps<T>
    | SelectMultipleSearchableProps<T>
): JSX.Element {
  if ("searchable" in props) {
    if ("multiple" in props) return <SelectMultipleSearchable {...props} />;
    return <SelectSingleSearchable {...props} />;
  }
  return <Select {...props} />;
}
